module.exports = __webpack_public_path__ + "img/logo.2383f23c.png";